import { createContext, useContext } from 'react';
import type { Site } from '@99designs/site-navigation/lib/Site';

export const SiteContext = createContext<Site | null>(null);

export function useSite(): Site {
    const value = useContext(SiteContext);

    if (!value) {
        throw new Error('useSite must be used within a SiteProvider');
    }
    return value;
}
